import { render, staticRenderFns } from "./CompanyTable2.vue?vue&type=template&id=74780cdf&scoped=true&"
import script from "./CompanyTable2.vue?vue&type=script&lang=js&"
export * from "./CompanyTable2.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTable2.vue?vue&type=style&index=0&id=74780cdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74780cdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
